<template>
  <div class="flex flex-col h-full gap-4">
    <div class="w-full flex flex-col gap-2 justify-start">
      <label
        class="font-medium mb-1"
        for="businessType"
        style="margin-top: 0.75rem;">סוג עסק</label>
      <div class="flex flex-wrap gap-3">
        <div class="flex align-items-center">
          <RadioButton
            v-model="businessType"
            inputId="smartbee-patur"
            name="smartbee-patur"
            value="patur" />
          <label for="smartbee-patur" class="mr-2">עוסק פטור</label>
        </div>
        <div class="flex align-items-center">
          <RadioButton
            v-model="businessType"
            inputId="smartbee-murshe"
            name="smartbee-murshe"
            value="murshe" />
          <label for="smartbee-murshe" class="mr-2">עוסק מורשה</label>
        </div>
      </div>
    </div>
    <div class="w-full flex flex-col gap-2 justify-start">
      <label
        class="font-medium mb-1"
        for="smartbeeUserToken"
        style="margin-top: 0.75rem;">מזהה משתמש (User Token)</label>
      <input-text
        id="smartbeeUserToken"
        v-model="credentials.providerUserToken"
        placeholder="*****"
      />
    </div>

    <div class="w-full pt-6 mt-auto flex flex-col gap-2">
      <Button
        label="הבא"
        class="w-full"
        :disabled="!filledEverything"
        @click="completeIntegration"
        :loading="isLoading"
      />
      <Button
        label="הקודם"
        outlined
        class=" w-full !rounded-3xl"
        style="display: flex; flex-grow: 1"
        @click="$emit('prev')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { InvoiceProvider, SmartBeeIntegrationParams } from '@torim-app/types';
import { SettingsApi } from '@app/api/admin';
import { useToast } from 'vue-toastification';

const emit = defineEmits(['next', 'prev']);
const toast = useToast();

const isLoading = ref(false);
const businessType = ref<'murshe' | 'patur'>();
const credentials = ref<SmartBeeIntegrationParams>({
  providerUserToken: ''
});

const filledEverything = computed<boolean>(() => {
  return !!businessType.value && Object.values(credentials.value).every(x => !!x);
});

const completeIntegration = async () => {
  if (filledEverything.value) {
    isLoading.value = true;
    try {
      await SettingsApi.updateSettingsAddInvoiceIntegration({
        credentials: credentials.value,
        provider: InvoiceProvider.SMARTBEE,
        // Decides whether we may issue a tax invoice (murshe) or only a receipt (patur).
        // Must match how the business is registered in SmartBee, or document creation fails.
        businessType: businessType.value
      });
      emit('next');
    } catch (e) {
      toast.error('לא הצלחנו להוסיף את החיבור ל-SmartBee');
      console.log(e);
    } finally {
      isLoading.value = false;
    }
  }
};


</script>

<style scoped lang="scss">

</style>
